import FileReaderUtils from '@/utils/fileReaderUtils'

async function getPictureAsync (options)
{
    return new Promise((resolve, reject) =>
    {
        navigator.camera.getPicture(resolve, reject, options)
    })
}

async function capturePictureAsync ()
{
    let pictureDataUrl

    if (cordova.platformId == 'browser')
    {
        const userVideo = await navigator.mediaDevices.getUserMedia({ video: true })
        const userVideoTrack = userVideo.getVideoTracks()[0]
        const photo = await new ImageCapture(userVideoTrack).takePhoto()
        
        pictureDataUrl = await FileReaderUtils.readAsDataURLAsync(photo)

        userVideoTrack.stop()
    }
    else
    {
        let options =
        {
            encodingType: navigator.camera.EncodingType.JPEG,
            quality: 60,
            correctOrientation: true,
            sourceType: navigator.camera.PictureSourceType.CAMERA,
            destinationType: navigator.camera.DestinationType.DATA_URL
        }

        const dataUrl = await getPictureAsync(options)
        pictureDataUrl = `data:image/jpeg;base64,${dataUrl}`
    }

    return pictureDataUrl
}

export default { capturePictureAsync }


// WEBPACK FOOTER //
// ./src/utils/cameraUtils.js